// extracted by mini-css-extract-plugin
export default {"button":"Login_button__NslsQ","loginpage":"Login_loginpage__6YdHa","footer":"Login_footer__-ZL2N"};